import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useDocumentTitle } from '~/hooks';
import { Header, Page } from '../components';
import TraceDetail from './TraceDetail';
import TraceList from './TraceList';

export default function TraceReplay() {
  useDocumentTitle('Trace Replay - Admin');

  const { path } = useRouteMatch();

  return (
    <Page>
      <Header />
      <Switch>
        <Route exact path={path}>
          <TraceList />
        </Route>
        <Route path={`${path}/:traceId`}>
          <TraceDetail />
        </Route>
      </Switch>
    </Page>
  );
}
